import React from "react";

export const ValidationEffect = ({ isSubmitting, isValid, callback }) => {
  React.useEffect(() => {
    if (!isSubmitting && !isValid) {
      callback();
    }
  }, [isSubmitting, isValid, callback]);
  return null;
};
